module.exports = __webpack_public_path__ + "img/6.4ae5e366.jpg";